import { render, staticRenderFns } from "./RestablecerPasswordView.vue?vue&type=template&id=2a105263"
import script from "./RestablecerPasswordView.vue?vue&type=script&lang=js"
export * from "./RestablecerPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports